import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public userHeader: BehaviorSubject<number>;
  public languageId: BehaviorSubject<any>;
  public languageCode: BehaviorSubject<any>;
  public selectedCollectionName: BehaviorSubject<any>;

  constructor() {
    this.userHeader = new BehaviorSubject<number>(0);
    this.languageId = new BehaviorSubject<any>(null);
    this.languageCode = new BehaviorSubject<any>(null);
    this.selectedCollectionName = new BehaviorSubject<any>(null);
  }

  changeUserHeader(value: number) {
    this.userHeader.next(value);
  }
}
